type FlagIconProps = {
  countryCode: string;
} & React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLSpanElement>,
  HTMLSpanElement
>;

export default function FlagIcon({
  countryCode,
  className,
  ...props
}: FlagIconProps) {
  return (
    <span
      className={`fi fi-${countryCode.toLowerCase()} ${className}`}
      {...props}
    ></span>
  );
}
